import React, { useState } from 'react';

const Twentyfifththeme = ({get_data}) => {
    const [cart, setCart] = useState([]);

    const addToCart = (item) => {
        setCart([...cart, item]);
        alert(`${item.service_name} added to cart!`);
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Coffee House */
            --coffee-dark: #3f2e3e;
            --coffee-med: #a0522d;
            --latte: #f5deb3;
            --cream: #fff8dc;
            --text-dark: #2c1810;
        }

        body { font-family: 'Merriweather', serif; background: var(--cream); color: var(--text-dark); margin: 0; }
        .container { max-width: 1000px; margin: 0 auto; padding: 0 30px; }
        
        .navbar { background: var(--coffee-dark); padding: 15px 0; color: var(--latte); }
        .nav-inner { display: flex; justify-content: space-between; align-items: center; }
        .brand { font-size: 1.8rem; font-weight: 900; letter-spacing: 1px; }
        .nav-links a { color: var(--latte); margin-left: 20px; text-decoration: none; font-size: 0.9rem; text-transform: uppercase; }
        
        .hero { text-align: center; padding: 100px 0; background: url('https://images.unsplash.com/photo-1497935586351-b67a49e012bf?ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80') center/cover; color: white; position: relative; }
        .hero::before { content: ''; position: absolute; inset: 0; background: rgba(44, 24, 16, 0.7); }
        .hero-content { position: relative; z-index: 1; }
        .hero h1 { font-size: 3.5rem; margin-bottom: 20px; font-style: italic; }
        
        .btn { background: var(--coffee-med); color: white; border: none; padding: 12px 30px; font-family: 'Merriweather', serif; font-size: 1rem; cursor: pointer; border-radius: 4px; transition: 0.3s; }
        .btn:hover { background: var(--coffee-dark); }
        
        .section-title { text-align: center; margin: 80px 0 50px; font-size: 2.5rem; position: relative; display: inline-block; width: 100%; }
        .section-title::after { content: '☕'; display: block; font-size: 1.5rem; margin-top: 10px; }
        
        .menu-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(400px, 1fr)); gap: 40px; }
        .menu-item { display: flex; align-items: flex-start; gap: 20px; background: white; padding: 20px; border-radius: 8px; box-shadow: 0 4px 10px rgba(0,0,0,0.05); }
        .menu-icon { font-size: 2rem; color: var(--coffee-med); }
        
        .product-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 30px; }
        .product-card { background: white; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 10px rgba(0,0,0,0.05); }
        .product-img { height: 200px; width: 100%; object-fit: cover; }
        
        .footer { background: var(--coffee-dark); color: var(--latte); padding: 50px 0; text-align: center; margin-top: 100px; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,700;0,900;1,400&display=swap" rel="stylesheet" />

            <nav className="navbar">
                <div className="container nav-inner">
                    <div className="brand">{get_data.service_name}</div>
                    <div className="nav-links">
                        <a href="#">Home</a>
                        <a href="#menu">Menu</a>
                        <a href="#store">Store</a>
                        <a href="#contact">Contact</a>
                    </div>
                </div>
            </nav>

            <div className="hero">
                <div className="container hero-content">
                    <h1>Warmth in Every Detail</h1>
                    <p style={{fontSize: '1.2rem', marginBottom: '40px', fontStyle: 'italic'}}>Cozy vibes, premium quality, and exceptional service.</p>
                    <a href="#menu" className="btn">Explore Menu</a>
                </div>
            </div>

            <div className="container">
                <div className="section-title" id="menu">Our Offerings</div>
                <div className="menu-grid">
                    {get_data.categories && get_data.categories.map((item, index) => (
                        <div className="menu-item" key={index}>
                            <div className="menu-icon">
                                 {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover'}} alt=""/> : <span>☕</span>}
                            </div>
                            <div>
                                <h3 style={{margin: '0 0 10px', fontSize: '1.2rem'}}>{item.name}</h3>
                                <p style={{margin: 0, fontSize: '0.9rem', lineHeight: 1.6, color: '#666'}}>{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
                
                <div className="section-title" id="store">Goods</div>
                <div className="product-grid">
                     {get_data.product_services && get_data.product_services.map((item, index) => (
                        <div className="product-card" key={index}>
                             <img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} className="product-img" alt={item.service_name}/>
                             <div style={{padding: '20px'}}>
                                 <h3>{item.service_name}</h3>
                                 {item.price && <div style={{fontWeight: 900, fontSize: '1.1rem', color: 'var(--coffee-med)', margin: '10px 0'}}>₹{item.price}</div>}
                                 <button onClick={() => addToCart(item)} className="btn" style={{width: '100%', fontSize: '0.9rem'}}>Add to Order</button>
                             </div>
                        </div>
                     ))}
                </div>
            </div>

            <footer className="footer" id="contact">
                <div className="container">
                    <h3>{get_data.service_name}</h3>
                    <p>{get_data.business_location_name}</p>
                    <p>{get_data.email}</p>
                </div>
            </footer>
        </>
    );
};

export default Twentyfifththeme;
